<template lang="pug">
.map-offcanvas__item
  .map-offcanvas__title
    span(uk-icon="icon: file-text; ratio: .7")
    div &nbsp;メモ
  .map-offcanvas__body
    .uk-text-meta ※最大{{ maxrows }}行まで入力できます。
    textarea.uk-textarea.map-offcanvas__memo(v-model="memo", :rows="maxrows")

</template>

<script>
import * as types from '../js/mutations/map-mutations'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    maxrows: 15,
  }),
  computed: {
    memo: {
      get () { return this.$store.getters.memo },
      set (value) { this.$store.dispatch(types.SET_MEMO, value) },
    },
  },
  watch: {
    memo (memo) {
      if (!memo) return
      const lines = memo.split("\n")
      if (lines.length > this.maxrows) {
        let result = ""
        for (let i = 0; i < this.maxrows; i++) {
          result += lines[i] + "\n"
        }
        this.memo = result
      }
    },
  },
}

</script>
